export default __webpack_public_path__ + "static/media/phoenix_6_11zon.d87dc461.png";